<template>
  <div class="neighbourEdit">
    <van-nav-bar fixed border right-text="发表" @click-right="onClickRight">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
      </template>
    </van-nav-bar>
    <van-cell-group style="margin-top:40px;">
      <van-field autosize type="textarea" v-model="circletext" border placeholder="这一刻的想法..." />
    </van-cell-group>
     <div>
       <div class="video-box" v-if="Object.keys(connentimg).length>2"  @click="playVideo(attach_url+connentimg.videoUrl)">
          <div style="display:flex;">
            <div>
              <img class="videocover" style="height:180px;width:130px;margin-left:15%;" :src="attach_url+connentimg.videoImgUrl" alt />
              <div class="video-img"></div>
            </div>
           <!-- <img style="width:25px;height:25px;margin-left:20px;" @click.stop="deleteimg()" src="../../assets/img/center/delete.png" class="icon"/> -->
          </div>
          <div :class="videoshow==true?'videoshow1':'videoshow'">
          <video :src="videoUrl" ref="msgvideo" style="width:200px;height:160px;" preload="auto"></video>
        </div>              
       </div>
    <div class="connentimg" v-else >
      <img v-show='item' class="addimg" v-for="(item,i) in imgList" :key="i"
       :src="attach_url+item"   @click.stop="showImage(attach_url+item)" alt=""/>
      <van-uploader class="uploadimg" max-count="8" capture :after-read="onSend" :before-read="beforeRead" accept="image/*">
      <img class="add"  src="../../assets/addplus.png" @click="addManage()" alt />
      </van-uploader>
    </div>
    </div>
    <van-popup
      style="width:90%;"
      v-model="showImgDialog"
      class="img_dialog"
      @click="showImgDialog=false"
      >
    <div class="delate">
       <img @click.stop="deleteimg()" style="width:25px;height:25px" src="../../assets/img/center/delete.png" alt="">
    </div>
     <img :src="image_url" style="width:100%;" @click="showImgDialog=false" />
    </van-popup>
  </div>
</template>
<script type="text/ecmascript-6">
import { chkImgType } from "@/utils/common.js";
import { compUploadImg } from "@/utils/chat.js";
export default {
  name: "NeighbourEdit",
  data() {
    return {
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      attach_url: this.Conf.serverPre,
      connentimg: "",
      circletext: "",
      circleimg:"",
      imgList:[],
      videoshow:false,
      videoUrl:"",
      image_url:"",
      showImgDialog:false,
    };
  },
  created() {
		this.getStateConfigs();
    var query = this.$route.query;
    this.connentimg = query.headimg;
    this.imgList.push(this.connentimg.imageUrl);
  },
  methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    goBack() {
      this.$router.push({
        path: "/NeighbourMoments",
      });
    },
    onClickRight() {
      if(Object.keys(this.connentimg).length<3){
      // this.imgList.push(this.connentimg.imageUrl);
        var imgUrl = "";
        for(var i in this.imgList){
           imgUrl += this.imgList[i]+','
        }
        if (imgUrl.length > 0) {
        imgUrl = imgUrl.substr(0, imgUrl.length - 1);
         }
      var params = {
        u_id: this.u_id,
        token: this.token,
        content: this.circletext,
        picture: imgUrl,
        location: "",
      };
      }else{
        var params = {
        u_id: this.u_id,
        token: this.token,
        content:this.circletext ,
        picture: this.connentimg.videoUrl,
        location: "",
      };
      }
      var url = this.Conf.serverUrl + "FriendCircle/addFriendCircle";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then((response) => {
          this.$router.push({
            name: "NeighbourMoments",
          });
        })
        .catch((error) => {});
    },
    //点击图片时去放大图片
     showImage(img) {
      this.showImgDialog = true;
      this.image_url = img;
    },
    deletevideo(){
       this.imgList.splice(this.videoUrl,1)
    },
    deleteimg(){
      console.log("hhhh",this.image_url)
      this.showImgDialog = false;
     this.imgList.splice(this.image_url,1)
    },
    beforeRead(file) {
      return chkImgType(file);
    },
    // 上传图片
    onSend(file) {
      let that = this;
      compUploadImg(file, function (f) {
        let data = {};
        data.message = f;
        data.friend_id = that.friend_id;
        data.u_id = that.u_id;
        data.mk = 3;
        data.type = "image";
        var url =
          that.Conf.serverUrl + "Chat/uploadImg" + "?num=" + Math.random();
        that.$axios
          .post(url, that.$qs.stringify(data))
          .then((response) => {
            that.imgList.push(response.data.imageUrl);
          })
          .catch((error) => {});
      });
    },
    playVideo(src) {
      var that = this;
      that.videoshow = true;
      var video = that.$refs.msgvideo;
      console.log("1111",video);
      that.videoUrl = src;
      if (video.paused) {
        that.FullSrceen();
        this.$nextTick(() => {
          video.play();
        });
        video.addEventListener("ended", () => {
          that.videoshow = false;
          video.load();
          that.exitFullscreen();
        });
        document.addEventListener("fullscreenchange", function (e) {
          if (document.fullscreenElement) {
            video.play();
          } else {
            that.videoshow = false;
            video.pause();
            // video.load();
          }
        });
        document.addEventListener("webkitfullscreenchange", function (e) {
          const isFullScreen =
            document.fullscreenEnabled ||
            window.fullScreen ||
            document.webkitIsFullScreen ||
            document.msFullscreenEnabled;
          if (isFullScreen) {
            video.play();
          } else {
            that.videoshow = false;
            video.pause();
            // video.load();
          }
        });
      }
    },
    //进入全屏
    FullSrceen() {
      var video = this.$refs.msgvideo;
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
      } else if (video.webkitRequestFullScreen) {
        video.webkitRequestFullScreen();
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
      } else {
        this.videoshow = false;
        video.play();
      }
    },
    //退出全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.oRequestFullscreen) {
        document.oCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },
  },
};
</script>
<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/components/My/NeighbourEdit.vue